import "./style.scss";

//  Components
import StyledButton from "components/shared/StyledButton";
import { whiteButton } from "components/TitlesList";
// React & Redux
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "store/store";
// Store
import { deleteAnalyticalCode } from "store/titleStore";
import type { IAnalyticalCodes } from "store/types";

interface IDeleteCode {
    code: IAnalyticalCodes | undefined;
    close: () => void;
}

const DeleteCode = ({ code, close }: IDeleteCode) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();

    const handleDelete = () => {
        dispatch(deleteAnalyticalCode(code)).then((resp) => {
            if (resp.meta.requestStatus === "fulfilled") {
                close();
            }
        });
    };

    return (
        <div className="delete-code-container">
            <p>
                {t("AnalyticalCode.DeleteText1")}
                <span style={{ fontWeight: "500" }}>{code?.name}</span>
                {t("AnalyticalCode.DeleteText2")}
            </p>
            <div className="code-modal-btns">
                <StyledButton onClick={() => close()} fullWidth sx={{ ...whiteButton, color: "#ED6E6E" }}>
                    {t("AnalyticalCode.Cancel")}
                </StyledButton>
                <StyledButton buttonType="primary" fullWidth onClick={() => handleDelete()}>
                    {t("AnalyticalCode.ConfirmDelete")}
                </StyledButton>
            </div>
        </div>
    );
};

export default DeleteCode;
